"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filebar_menu_html_1 = __importDefault(require("./filebar-menu.html"));
(function (module) {
    ViewMenuController.$inject = [
        '$filter',
        '$scope',
        'pr.navigationService',
        'prViewOptions',
        'prMetricsService',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS'
    ];
    function ViewMenuController($filter, $scope, navigationService, viewOptions, metricsService, triggerOverrides, OVERRIDE_EVENTS) {
        var $ctrl = this, translate = $filter('translate');
        var configFlags = triggerOverrides({
            event: OVERRIDE_EVENTS.CONFIG_FLAGS,
            sync: true,
            data: {}
        });
        angular.extend($ctrl, {
            id: 'VIEW',
            label: translate('VIEW'),
            isMultiSelect: true,
            getMenuItems: function () {
                var items = [{
                        label: translate('PAGE_MARGINS'),
                        selected: viewOptions.showMargins(),
                        action: viewOptions.toggleMargins
                    }, {
                        label: translate('PAGE_GRID'),
                        selected: viewOptions.showGrid(),
                        action: viewOptions.toggleGrid
                    }, {
                        label: translate('OUTLINES'),
                        selected: viewOptions.showOutlines(),
                        action: viewOptions.toggleOutlines
                    }, {
                        label: translate('PR.HIGHLIGHT_BLANK_SPACE'),
                        selected: viewOptions.showHighlights(),
                        action: viewOptions.toggleHighlights
                    }, {
                        divider: true
                    }, {
                        label: translate('ZOOM'),
                        submenu: {
                            selectMenu: true,
                            items: viewOptions.getZoomItems,
                            action: function (zoom) {
                                viewOptions.zoom(zoom);
                                $scope.$root.$digest();
                            }
                        }
                    }];
                if (!configFlags.disablePreview) {
                    items = _.concat(items, [{
                            divider: true
                        }, {
                            label: translate('PR.PREVIEW_PUBLIC_REPORT'),
                            icon: 'icon-open',
                            action: function () {
                                navigationService.loadPreview(metricsService.CALL_SOURCE.DROPDOWN);
                            },
                            replaceCheck: true
                        }]);
                }
                return items;
            }
        });
    }
    module.component('prViewMenu', {
        controller: ViewMenuController,
        templateUrl: filebar_menu_html_1.default,
        require: {
            fbCtrl: '^^prFilebar'
        }
    });
}(angular.module('qualtrics.pr')));
